export default IconRadar2 => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-radar-2" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
  <path d="M15.51 15.56a5 5 0 1 0 -3.51 1.44" />
  <path d="M18.832 17.86a9 9 0 1 0 -6.832 3.14" />
  <path d="M12 12v9" />
</svg>`;